<template>
  <input
    v-model="model"
    data-test-id="base-input"
    @change="$emit('change', ($event?.target as HTMLInputElement)?.value)"
  >
</template>

<script lang="ts" setup>
defineEmits<{ change: [value: string] }>()

const [model, modifiers] = defineModel<string | number>({
  set(value) {
    if (typeof value === 'string') {
      if (modifiers.capitalize)
        return value.charAt(0).toUpperCase() + value.slice(1)
      if (modifiers.uppercase)
        return value.toUpperCase()
      if (modifiers.lowercase)
        return value.toLowerCase()
    }

    return value
  }
})

defineExpose(getCurrentInstance()?.proxy!)
</script>
